module.exports = function negotiateAwbReference(model, referenceValue = '') {
	if(referenceValue.charAt(3) === '-')
		model.awbReference = referenceValue;
	else if(referenceValue.length > 4)
		model.billOfLadingReference = referenceValue;
};